import VideoPlayIcon from './component.jsx'
export default VideoPlayIcon
